import { CSSProperties, memo } from 'react'
import classNames from 'classnames'

import s from './Overlay.module.less'

interface IProps {
  className?: string
  id?: string
  style?: CSSProperties
}

export const Overlay = memo<IProps>(function Overlay({ className, id, style }) {
  return (
    <div id={id ? `${id}-overlay` : undefined}>
      <div className={classNames(s.Overlay, className)} data-component="modal" style={style} />
    </div>
  )
})
